(window["webpackJsonp_N_E"] = window["webpackJsonp_N_E"] || []).push([[441],{

/***/ "Hhno":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Creditcard", function() { return Creditcard; });
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("cxan");
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("HbGN");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_2__);


var __jsx = react__WEBPACK_IMPORTED_MODULE_2___default.a.createElement;

var Creditcard = function Creditcard(_ref) {
  var xRef = _ref.xRef,
      props = Object(_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])(_ref, ["xRef"]);

  return __jsx("svg", Object(_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])({
    viewBox: "0 0 30 30"
  }, props, {
    ref: xRef
  }), __jsx("path", {
    fillRule: "evenodd",
    d: "M6.13 6h17.74C25.59 6 27 7.4 27 9.13v12.05a3.13 3.13 0 0 1-3.12 3.13H6.13A3.14 3.14 0 0 1 3 21.18V9.13C3 7.41 4.4 6 6.13 6Zm17.75 2H6.13C5.51 8 5 8.51 5 9.13v1.24l20-.06V9.13C25 8.51 24.5 8 23.89 8Zm0 14.31A1.1 1.1 0 0 0 25 21.19v-8.87l-20 .06v8.8c0 .62.51 1.13 1.13 1.13H23.9Zm-4.6-6.89a3.08 3.08 0 1 1 1.56 5.72c-.56 0-1.1-.17-1.55-.44a3.08 3.08 0 1 1 0-5.28Zm-1.56 1.56c-.6 0-1.08.48-1.08 1.08v.01c0 .6.48 1.08 1.08 1.08.08 0 .16-.02.24-.04a3.05 3.05 0 0 1 0-2.09c-.08-.02-.16-.04-.24-.04Zm2.05 1.08c0 .6.48 1.08 1.08 1.08.59 0 1.08-.49 1.08-1.08a1.08 1.08 0 0 0-2.16 0Zm-12.74.38h3.83a1 1 0 0 0 1-1 1 1 0 0 0-1-1H7.03a1 1 0 0 0-1 1 1 1 0 0 0 1 1Zm0 .7h5.3a1 1 0 0 1 1 1 1 1 0 0 1-1 1h-5.3a1 1 0 0 1-1-1 1 1 0 0 1 1-1Z"
  }));
};

/***/ })

}]);